import { ReactComponent as Logo } from '@/assets/svgs/logo-sgtradex.svg'
import Button from '@/components/Button'
import DexLeftComponent from '@/components/DexLeftComponent'
import DexSignupSuccess from '@/components/DexSignupSuccess/index'
import Toast from '@/components/Toast'
import { useBuildex } from '@/hooks/use-buildex/index'
import usePage from '@/hooks/use-page'
import useToast from '@/hooks/use-toast'
import TradexSignup from '@/pages/signup/tradex-signup'
import API_SIGNUP from '@/services/api/signUp'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import BuildexSignup from './buildex-signup'
import { useNavigate } from '@/lib/router-dom/index'
import { useHealthdex } from '@/hooks/use-healthdex/index'	


const Page = () => {

	/*=================================================
		General
	/================================================*/

	const toastType = {
		success: "success",
		error: "error"
	}

	usePage({ title: 'Sign Up' })

	const [country, setCountry] = useState()
	const [industry, setIndustry] = useState()


	/*=================================================
		API
	/================================================*/

	const { register, handleSubmit, formState: { errors, isValid }, trigger, setValue, watch, control, reset} = useForm({
		mode: 'onChange'
	})
	const { toastList, addToastMessage } = useToast();
	const [loading, setLoading] = useState(false);
	const isBuildex = useBuildex();
	const isHealthdex = useHealthdex();

	/*=================================================
		API Action Functions
	/================================================*/

	async function loginHandler(data) {
		if (loading) {
			return
		}
		setLoading(true)
		let payload = {
			email: data.email.toLowerCase(),
			firstName: data.firstName,
			lastName: data.lastName,
			mobileNumber: data.mobileNo || null,
			org: {
				name: data.company,
				country: country || null,
				industry: industry || null
			}
		}

		if(isBuildex || isHealthdex) {
			payload = {...data}
		}

		const [error] = await API_SIGNUP.create(payload)

		if (error) {
			setLoading(false)
			return addToastMessage(error.message ?? "Failed to register account.", toastType.error)
		}
		setLoading(false)
		nextStep()
	}

	const handleKeyPress = (event) => {
		const indexOfPlus = event.target.value.indexOf("+");
		if (!/[0-9+]/.test(event.key)) {
			event.preventDefault();
		}
		if (event.target.value.indexOf(" ") >= 0 || indexOfPlus > 0) {
			event.preventDefault();
		}
	}

	/*=================================================
		Step
	/================================================*/

	const [step, setStep] = useState(1);
	const {goTo}  = useNavigate()

	function goToStep(newStep) {
		if (newStep < 1 || newStep > 2) {
			return;
		}
		setStep(newStep);
	}

	function prevStep() {
		goTo("/login")
	}

	function nextStep() {
		goToStep(step + 1);
	}

	/*=================================================
		MultiDex
	/================================================*/


	return (
		<div className='layout-login'>
			{step === 1 && (
				<>
					<DexLeftComponent />

					{isBuildex || isHealthdex ? (
						<BuildexSignup
							errors={errors}
							register={register}
							trigger={trigger}
							setValue={setValue}
							watch={watch}
							isValid={isValid}
							loading={loading}
							handleSubmit={handleSubmit}
							loginHandler={loginHandler}
							control={control}
							reset={reset}
						/>
					): (
						<div className='layout-login__right layout-login__right--grey'>
							<div className="login-box width-full">
								<div className='login-box__title--header-1' data-testid="page-title">Sign Up</div>
								<div className="login-box__content">
								<form className="login-box__form" onSubmit={handleSubmit((data) => loginHandler(data))}>
										<TradexSignup
											register={register}
											trigger={trigger}
											errors={errors}
											isValid={isValid}
											loading={loading}
											setCountry={setCountry}
											setIndustry={setIndustry}
											handleKeyPress={handleKeyPress}
										/>
								</form>
								</div>
							</div>
						</div>
					)}
				</>
			)}
			{step === 2 && (
				isBuildex || isHealthdex ? (
					<DexSignupSuccess prevStep={prevStep}/>
				) : (
					<>
						<div className='layout-login__logo'>
							<Logo/>
					</div>
					<div className="layout-feedback layout-feedback--full">

						<div className="layout-feedback__content">
							<img src="/sign-up-success.png" alt='sign-up-success'/>
						</div>
						<div className="layout-feedback__subheader layout-feedback__subheader--center layout-feedback__subheader--success layout-feedback__subheader--header">
							Account created successfully.
						</div>
						<div className="layout-feedback__subheader layout-feedback__subheader--center">
							Please check your email for a link to set your password and access the rest of SGTraDex content.
						</div>

						<div className="layout-feedback__footer">
							<Button sizing='Medium' text='Back to Home' maxWidth="278" full round submit={() => prevStep()} />
						</div>
					</div>
				</>
				)
			)}

			<Toast toastList={toastList} />
		</div>
	)
}
export default Page
